import styled from 'styled-components';

interface ContentProps {
  justifyBadge?: string;
  $clickable?: boolean;
}
interface BadgeProps {
  backgroundColor?: string;
}
interface TextProps {
  color?: string;
  fontWeight?: string | number;
  fontSize?: string | number;
  textMargin?: string;
  justifyBadge?: string;
}

export const Content = styled.div<ContentProps>`
  display: flex;
  align-items: center;
  justify-content: ${({ justifyBadge }) => justifyBadge ?? 'normal'};
  width: 100%;
  gap: 5px;
  :hover {
    cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'none')};
  }
`;

export const BadgeIcon = styled.div<BadgeProps>`
  min-height: 12px;
  height: 12px;
  min-width: 12px;
  width: 12px;
  border-radius: 50%;
  background-color: ${({ backgroundColor }) =>
    backgroundColor || 'transparent'};
`;

export const Text = styled.div<TextProps>`
  color: ${({ color }) => color};
  font-weight: ${({ fontWeight }) => fontWeight};
  font-size: ${({ fontSize }) => fontSize};
  margin-left: ${({ textMargin }) => textMargin ?? '10px'};
`;
